import { WSQueryResult } from "@ws-react-query";
import { ISessionResponse } from "@wingspanhq/users/dist/lib/interfaces";
import { WSServiceError } from "../../utils/serviceHelper";
import { useEffect, useState } from "react";
import { useQueryCustomization } from "../../query/customization/queries/useQueryCustomization";
import "./styles.scss";

export const useInitCustomization = (
  querySession: WSQueryResult<ISessionResponse, WSServiceError>
) => {
  const [isLoading, setIsLoading] = useState(true);
  const isReadyToFetch = !!querySession.data?.userId;
  const isSessionFetched = querySession.isFetched;

  const queryCustomization = useQueryCustomization({
    enabled: isReadyToFetch,
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    onSuccess(data) {
      if (data.support?.portal?.generalUrl) {
        window.document.body.setAttribute("data-no-intercom", "true");
      }
    }
  });

  const isCustomizationFetched = queryCustomization.isFetched;

  useEffect(() => {
    if (isSessionFetched && isReadyToFetch && isCustomizationFetched) {
      setIsLoading(false);
    } else if (isSessionFetched && !isReadyToFetch) {
      setIsLoading(false);
    }
  }, [isSessionFetched, isCustomizationFetched, isReadyToFetch]);

  return {
    isLoading: isLoading
  };
};
